export default __webpack_public_path__ + "static/17_31-16430b5539035d14e156122fa0996524.png";